module.exports = __webpack_public_path__ + "static/media/i.7ba57c97.png";